import {Storage} from "platform/storage/Storage";

export class DummyStorage implements Storage {

    private static _instance: Storage;

    private constructor() {
    }

    public static instance(): Storage {
        return this._instance || (this._instance = new this());
    }

    public setItem(key: string, data: string): void {
    }

    public getItem(key: string): Promise<string | any> {
        return Promise.resolve(null);
    }

    public removeItem(key: string): void {
    }
}
